<div class="wrapper">
    <div class="content-wrapper">
        @for (item of items; track item.id) {
            @if (!item.hidden) {
                <button
                    type="button"
                    class="segment-item"
                    (click)="onItemClick(item)"
                    [class.selected]="item.id === activeId"
                    [attr.data-testid]="'SegmentedToggle-Item-' + item.id"
                >{{ item.labelKey | translate }}</button>
            }
        }
    </div>
</div>
